/**
 * This is the native app bridge to connect and send/receive information from the native mobile apps (iOS/Android)
 */
const AppBridge = {
  sendMessage: (messageType, payload = {}) => {
    console.log(`Sending message to app bridge: ${messageType}`, payload);

    // Check for iOS bridge
    if (window.webkit?.messageHandlers?.iosAppBridge) {
      window.webkit.messageHandlers.iosAppBridge.postMessage({
        type: messageType,
        ...payload,
      });
      console.log('Message sent to iOS App Bridge');
    }
    // Check for Android bridge
    else if (window.androidAppBridge) {
      window.androidAppBridge.handleMessageFromJS(
        JSON.stringify({
          type: messageType,
          ...payload,
        })
      );
      console.log('Message sent to Android App Bridge');
    } else {
      console.error('No App Bridge available!');
    }
  },
};

export default AppBridge;
